import { gql } from "@apollo/client";

const CB_CONFIRM_TRANSACTION = gql`
	mutation CBConfirmTransaction(
		$purchaseToken: String!
		$productId: String!
		$developerPayload: String!
	) {
		CBConfirmTransaction(
			purchaseToken: $purchaseToken
			productId: $productId
			developerPayload: $developerPayload
		) {
			result
			errors
		}
	}
`;

export default CB_CONFIRM_TRANSACTION;
